import "./Card.scss";

export const Card = (props: { children?: any, className?: string, style?: React.CSSProperties }) => 
{
    const { children, className, ...otherProps } = props;

    return (
        <div className={[className, 'card'].join(' ')} {...otherProps}>{props.children}</div>
    );
}